import { inject, Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalImageComponent } from './modal-image.component';

@Injectable({
    providedIn: 'root'
})
export class ModalImageService {

    private modalService: NgbModal = inject(NgbModal);

    public open(
        titulo: string,
        imageUrl: string,
        downloadFileName: string,
        dialogSize: 'sm' | 'md' | 'lg' | 'xl' = 'lg'
    ): Promise<boolean> {
        const modalRef = this.modalService.open(ModalImageComponent, { 
            size: dialogSize, 
            backdrop: 'static', 
            keyboard: false,
            centered: true 
        });
        modalRef.componentInstance.titulo = titulo;
        modalRef.componentInstance.imageUrl = imageUrl;
        modalRef.componentInstance.downloadFileName = downloadFileName;

        return modalRef.result;
    }

    
}